import { GatewayService } from '../GatewayService';
import { environment } from 'src/environments/environment';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class LoginModel {
    usuario: String
    senha: String

    loginUsuario(loginModel: LoginModel): Promise<PhicubeResponse> {
        const data = {
            "grant_type": "password",
            "client_id": environment.clientId,
            "client_secret": environment.clientSecret,
            "username": loginModel.usuario,
            "password": loginModel.senha
        }
        return new GatewayService().requestPost('/api/oauth/token', data, true)
    }

    getCarrosseis(): Promise<PhicubeResponse> {
        return new GatewayService().requestGet('/api/carrosseis/login', true)
    }
}